import React, { useCallback, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setActiveAssistant } from "../../store/slices/assistantSlice";
import { setActiveDialog } from "../../store/slices/dialogSlice";
import NavItem from "../../ui/NavItem/NavItem";
import HistoryChatContainer from "../HistoryChatContainer/HistoryChatContainer";
import styles from "./LeftNavBar.module.scss";
import QuestionIcon from "../../assets/icons/QuestionIcon";
import { UserContainer } from "./UserContainer";

export default function LeftNavBar({ navData, pathname }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const dialogs = useSelector((state) => state.dialog.data);
  const activeDialog = useSelector((state) => state.dialog.activeDialog);
  const assistants = useSelector((state) => state.assistant.dataAssistants);
  const activeAssistant = useSelector(
    (state) => state.assistant.activeAssistant
  );

  const [visibleList, setVisibleList] = useState(false);
  const [indexItemNav, setIndexItemNav] = useState(-1);

  const getActiveDialog = useCallback(() => {
    if (!activeDialog && dialogs) return dialogs[0];
    if (activeDialog) return activeDialog;
    return null;
  }, [activeDialog, dialogs]);

  const getActiveAssistant = useCallback(() => {
    if (!activeAssistant && assistants) return assistants[0];
    if (activeAssistant) return activeAssistant;
    return null;
  }, [activeAssistant, assistants]);

  React.useEffect(() => {
    if (location.pathname === "/dialog")
      dispatch(setActiveDialog(getActiveDialog()));
  }, [dialogs, dispatch, getActiveDialog, location.pathname]);

  React.useEffect(() => {
    if (location.pathname === "/assistants") {
      dispatch(setActiveAssistant(getActiveAssistant()));
      localStorage.setItem(
        "activeAssistant",
        JSON.stringify(getActiveAssistant())
      );
    }
  }, [assistants, dispatch, getActiveAssistant, location.pathname]);

  const activePathObserver = (path) => location.pathname.startsWith(path);

  const handlerNavigation = (path) => {
    navigate(path);
  };

  const changeIndex = (index) => {
    setIndexItemNav(index);
    setVisibleList(!visibleList);
  };

  const renderNavItem = (arr) => {
    return arr.map((el, index) => {
      if (el.child) {
        return (
          <div key={el.pathname}>
            <NavItem
              icon={el.icon}
              title={el.title}
              onClick={() => changeIndex(index)}
            />
            {index === indexItemNav && visibleList && renderNavItem(el.child)}
          </div>
        );
      } else {
        return (
          <NavItem
            icon={el.icon}
            title={el.title}
            key={el.pathname}
            active={activePathObserver(el.pathname)}
            onClick={() => handlerNavigation(el.pathname)}
          />
        );
      }
    });
  };

  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.nav}`}>
        <nav>{renderNavItem(navData)}</nav>
      </div>
      <div className={`${styles.history_chat}`}>
        {pathname === "/dialog" && <HistoryChatContainer dialogs={dialogs} />}
        {pathname === "/assistants" && (
          <HistoryChatContainer assistants={assistants} />
        )}
      </div>
      <div className={`${styles.bottom_nav}`}>
        <div className={styles.itemQuestion}>
          <QuestionIcon />
          <p>Помощь</p>
        </div>
        <UserContainer />
      </div>
    </div>
  );
}
